import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {IFilterQueryHR} from '../core/_models'
import {enableMapSet} from 'immer'

enableMapSet()
export interface HRFilterState {
  query?: IFilterQueryHR
}

const initialState: HRFilterState = {}

const hrFilterSlice = createSlice({
  name: 'hrFilter',
  initialState: initialState,
  reducers: {
    updateQuery(state, action: PayloadAction<Partial<IFilterQueryHR>>) {
      const payload = action.payload
      state.query = {
        ...state.query,
        ...payload,
      }
    },

    setQuery(state, action: PayloadAction<IFilterQueryHR>) {
      state.query = action.payload
    },

    resetQuery(state) {
      state.query = {
        ...state.query,
        rules: undefined,
      }
    },
  },
})

export const {resetQuery, setQuery, updateQuery} = hrFilterSlice.actions
export default hrFilterSlice.reducer
